<aside class="modern-sidebar" dir="rtl">
  <div class="sidebar-header">
    <h3>تصنيف الخدمات</h3>
  </div>

  <nav class="sidebar-nav">

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=1" class="sidebar-item active"
      title="خدمات تأسيس الشركات">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/PublishingImages/samah2.png" alt="">
      </div>
      <span class="item-text">خدمات تأسيس الشركات</span>
      <i class="fas fa-check item-check"></i>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=23" class="sidebar-item"
      title="إرسال مستندات لإتمام الخدمات">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/regestration.png" alt="">
      </div>
      <span class="item-text">إرسال مستندات لإتمام الخدمات</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=22" class="sidebar-item"
      title="المسئولية المجتمعية للشركات/الاستدامة">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/regestration.png" alt="">
      </div>
      <span class="item-text">المسئولية المجتمعية للشركات/الاستدامة</span>
    </a>

    <a routerLink="/arabic/eServices/Pages/Services" routerLinkActive="active" class="sidebar-item"
      title="الرخصة الذهبية">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/PublishingImages/samah2.png" alt="الرخصة الذهبية">
      </div>
      <span class="item-text">الرخصة الذهبية</span>
      <i class="fas fa-chevron-left item-arrow"></i>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=17" class="sidebar-item"
      title="خدمات اعتماد وكلاء المستثمرين">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/regestration.png" alt="">
      </div>
      <span class="item-text">خدمات اعتماد وكلاء المستثمرين</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=15" class="sidebar-item"
      title="صحيفة الاستثمار الإلكترونية">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/PublishingImages/amal35.png" alt="">
      </div>
      <span class="item-text">صحيفة الاستثمار الإلكترونية</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=16" class="sidebar-item" title="تراخيص الاستثمار">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/PublishingImages/samah2.png" alt="">
      </div>
      <span class="item-text">تراخيص الاستثمار</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=3" class="sidebar-item" title="خدمة عدم الالتباس">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/write-letter.png" alt="">
      </div>
      <span class="item-text">خدمة عدم الالتباس</span>
    </a>

    <!-- الصفحة الحالية (مفعلة) -->


    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=2" class="sidebar-item" title="خدمات الجمعيات">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/government-service.png" alt="">
      </div>
      <span class="item-text">خدمات الجمعيات</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=4" class="sidebar-item" title="خدمات تعديلات الشركات">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/tools.png" alt="">
      </div>
      <span class="item-text">خدمات تعديلات الشركات</span>
    </a>

    <a href="/arabic/eServices/Pages/Services.aspx?DepartmentID=5" class="sidebar-item"
      title="تقارير الاستثمار الأجنبى المباشر">
      <div class="item-icon">
        <img src="https://www.gafi.gov.eg/Style%20Library/GAFIStyles/Images/eservices26.png" alt="">
      </div>
      <span class="item-text">تقارير الاستثمار الأجنبى المباشر</span>
    </a>
  </nav>
</aside>